import Tracker from './Tracker'

class Rokt extends Tracker {
  checkMethod = () => !!window?.Rokt

  async init() {
    /* istanbul ignore next */
    !(async function (r, o) {
      const target = o.head || o.body
      const script = o.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://apps.rokt.com/wsdk/integrations/launcher.js'
      script.importance = 'high'
      script.crossOrigin = 'anonymous'
      script.async = true
      script.id = 'rokt-launcher'

      target.appendChild(script)

      await new Promise((resolve) =>
        r.Rokt ? resolve() : o.getElementById('rokt-launcher').addEventListener('load', () => resolve())
      )
    })(window, document)
  }

  event(event, firstLoad, args) {
    let checker,
      count = 0
    const fireEvent = async () => {
      count++
      if (this.checkMethod()) {
        /* istanbul ignore else  */
        if (event === 'success') {
          await this.fireLauncherEvent(args)
        }
        clearInterval(checker)
      } else if (count >= 5) {
        clearInterval(checker)
      }
    }

    if (this.checkMethod()) {
      fireEvent()
    } else {
      checker = setInterval(fireEvent, 1000)
    }
  }

  async fireLauncherEvent(args) {
    const launcher = await window.Rokt.createLauncher({
      accountId: this.props.roktId,
    })
    await launcher.selectPlacements({
      attributes: args,
    })
  }
}

export default Rokt
